import { LOGIN, LOGOUT } from "../actions/types";
import {
  getStorage,
  checkStorage,
  setStorage,
} from "../../helperComponents/locale-storage";
const initial_state = {
  login_token: checkStorage("login_token") ? getStorage("login_token") : "",
  is_logged: checkStorage("is_logged") ? getStorage("is_logged") : "false",
  user_info: checkStorage("userInfo") ? JSON.parse(getStorage("userInfo")) : {},
};

export default function (state = initial_state, action) {
  switch (action.type) {
    case LOGIN:
      console.log("data", action.payload);
      return {
        ...state,
        login_token: action.payload.token,
        is_logged: "true",
        user_info: action.payload.data,
      };
    case LOGOUT:
      return {
        ...state,
        login_token: "",
        is_logged: "false",
        user_info: {},
      };

    default:
      return state;
  }
}
